module.exports = {
  portal: {
    title: "Portal: единая рабочая среда компании",
    heroBadge: "SmartTeamDev Portal",
    subtitle: "Корпоративная платформа для управления доступом, документами, бухгалтерией, лабораторией, транспортом, СКУД и интеграциями.",
    summaryTitle: "Что решает портал",
    summaryText: "Portal объединяет распределенные бизнес-процессы в едином интерфейсе /app. Пользователь получает доступ только к разрешенным приложениям, а действия фиксируются в журналах аудита.",
    summaryPoints: [
      "AD и FBA-аккаунты в единой модели доступа",
      "Модульные приложения apps/* с едиными правилами прав",
      "Интеграции: 1С, банки, Контур.Фокус, DaData, СКУД, FortMonitor",
      "Централизованное логирование и AI-ассистент для анализа"
    ],
    stats: [
      { value: "35+", label: "приложений" },
      { value: "10+", label: "интеграций" },
      { value: "24/7", label: "мониторинг логов" }
    ],
    integrationsTitle: "Карта интеграций",
    integrationsSubtitle: "Интерактивная схема показывает ключевые контуры, подключенные к ядру Portal",
    integrationShares: [
      { name: "Active Directory / LDAP", value: 18, color: "#3b82f6" },
      { name: "1С + банковские API", value: 22, color: "#10b981" },
      { name: "СКУД / Mikrotik", value: 16, color: "#f59e0b" },
      { name: "Контур.Фокус / DaData", value: 14, color: "#ef4444" },
      { name: "FortMonitor / Карты", value: 12, color: "#a855f7" },
      { name: "OpenAI / WOPI / мессенджеры", value: 18, color: "#06b6d4" }
    ],
    appsTitle: "Просмотр приложений",
    appsSubtitle: "Выберите направление и получите список приложений с назначением",
    openAppLabel: "Открыть модуль",
    appFilters: [
      { code: "all", label: "Все" },
      { code: "document", label: "Документооборот" },
      { code: "accounting", label: "Бухгалтерия" },
      { code: "laboratory", label: "Лаборатория" },
      { code: "control", label: "СКУД и мониторинг" },
      { code: "platform", label: "Система" }
    ],
    appCatalog: [
      {
        title: "contragents",
        riIcon: "RiFileList3Line",
        area: "Документооборот",
        href: "/app/pw/contragents",
        categories: ["all", "document"],
        description: "Карточки контрагентов с проверкой реквизитов и рисков через внешние сервисы.",
        features: ["DaData и Контур.Фокус", "История изменений", "Уведомления ответственным"]
      },
      {
        title: "waybills",
        riIcon: "RiMapPinLine",
        area: "Транспорт",
        href: "/app/pw/waybills",
        categories: ["all", "document", "control"],
        description: "Учет поездок, маршрутов, топлива и печатных форм путевых листов.",
        features: ["Связь с автопарком", "Аналитика поездок", "PDF-формы"]
      },
      {
        title: "banksoperations",
        riIcon: "RiBankLine",
        area: "Бухгалтерия",
        href: "/app/accounting/banksoperations",
        categories: ["all", "accounting"],
        description: "Импорт и обработка банковских операций с маркировкой важных платежей.",
        features: ["Автоимпорт по API", "Контроль сумм", "Привязка к договорам"]
      },
      {
        title: "lab_equipment",
        riIcon: "RiApps2Line",
        area: "Лаборатория",
        href: "/app/laboratory/lab_equipment",
        categories: ["all", "laboratory"],
        description: "Учет лабораторного оборудования и состояния технической базы.",
        features: ["Группы и паспорта", "Связь с НТД", "Журнал обслуживания"]
      },
      {
        title: "chatgpt",
        riIcon: "RiRobot2Line",
        area: "Система",
        href: "/app/system/chatgpt",
        categories: ["all", "platform"],
        description: "AI-помощник для анализа файлов, логов и типовых вопросов пользователей.",
        features: ["История диалогов", "Разбор логов", "Работа с вложениями"]
      },
      {
        title: "syslogserver",
        riIcon: "RiShieldCheckLine",
        area: "СКУД и мониторинг",
        href: "/app/system/syslogserver",
        categories: ["all", "control", "platform"],
        description: "Централизованный аудит действий пользователей и системных событий.",
        features: ["Фильтры по событиям", "Экспорт отчетов", "Хронология действий"]
      }
    ],
    cardsTitle: "Техническая архитектура",
    cardsSubtitle: "Ключевые компоненты, обеспечивающие масштабируемость и надежность",
    cards: [
      { riIcon: "RiReactjsLine", title: "Client SPA", text: "React + Redux + Ant Design, рабочий стол и виджеты на /app." },
      { riIcon: "RiNodejsLine", title: "Node.js Backend", text: "Express, socket.io, API-шлюзы и серверный рендер страниц." },
      { riIcon: "RiDatabase2Line", title: "Data Layer", text: "MongoDB с разделением системных и бизнес-данных." },
      { riIcon: "RiSettings4Line", title: "Service Scheduler", text: "Фоновые задачи синхронизации, очистки и интеграционных обновлений." }
    ],
    workflowTitle: "Сценарий запуска портала",
    workflowSubtitle: "Пошаговый ввод в эксплуатацию без остановки текущих процессов",
    workflow: [
      { num: "01", riIcon: "RiSearchLine", title: "Аудит контуров", text: "Проверяем ИТ-ландшафт, источники данных и роли пользователей." },
      { num: "02", riIcon: "RiServerLine", title: "Развертывание", text: "Поднимаем инфраструктуру и подключаем базовые сервисы платформы." },
      { num: "03", riIcon: "RiArrowRightUpLine", title: "Интеграции", text: "Поэтапно подключаем 1С, AD, банки, СКУД и внешние API." },
      { num: "04", riIcon: "RiCheckboxCircleLine", title: "Ввод в работу", text: "Обучаем сотрудников, фиксируем регламенты и запускаем поддержку." }
    ],
    listTitle: "Результат для бизнеса",
    listSubtitle: "Что компания получает после внедрения",
    listItems: [
      "Единый цифровой контур вместо разрозненных сервисов",
      "Сокращение ручных операций и дублирования данных",
      "Прозрачность действий пользователей и событий безопасности",
      "Быстрый доступ руководства к актуальной аналитике"
    ],
    ctaTitle: "Запросить демонстрацию",
    ctaText: "Покажем Portal на реальных сценариях вашей команды и подготовим план внедрения.",
    primaryHref: "/pages/contact",
    primaryLabel: "Связаться",
    secondaryHref: "/pages/services",
    secondaryLabel: "Посмотреть сервисы",
    presentationBtn: "Смотреть презентацию",
    presentationHref: "/pages/presentation-app",
    forWhomTitle: "Для кого Portal",
    forWhomSubtitle: "Платформа создана для промышленных предприятий с разветвлённой структурой подразделений",
    forWhomItems: [
      {
        riIcon: "RiBuildingLine",
        title: "Промышленные компании",
        text: "Предприятия с множеством подразделений и сложными внутренними процессами."
      },
      {
        riIcon: "RiGroupLine",
        title: "IT-отделы предприятий",
        text: "Команды, которым нужна управляемая платформа без облачных зависимостей."
      },
      {
        riIcon: "RiUserStarLine",
        title: "Руководители и аналитики",
        text: "Менеджеры, которым важны актуальные данные и инструменты принятия решений."
      },
      {
        riIcon: "RiAccountBoxLine",
        title: "Рядовые сотрудники",
        text: "Пользователи с доступом только к нужным приложениям через единый интерфейс."
      }
    ]
  }
};
